package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class TaskQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_357_059_194, arrayOf("task"), driver, "Task.sq", "selectAll",
      "SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task WHERE is_deleted = 0 ORDER BY due_date IS NULL, due_date, order_index") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectAll(): Query<Task> = selectAll { id, parent_kind, parent_id, status_id, title,
      description, status, priority, effort, due_date, estimated_minutes, real_minutes, recurrence,
      pomodoro_pool_date, order_index, completed_at, kind, deliverable, acceptance, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id,
      parent_kind,
      parent_id,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectById(id: String): Query<Task> = selectById(id) { id_, parent_kind, parent_id,
      status_id, title, description, status, priority, effort, due_date, estimated_minutes,
      real_minutes, recurrence, pomodoro_pool_date, order_index, completed_at, kind, deliverable,
      acceptance, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id_,
      parent_kind,
      parent_id,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByParent(
    parent_kind: String,
    parent_id: String?,
    mapper: (
      id: String,
      parent_kind: String,
      parent_id: String?,
      status_id: String?,
      title: String,
      description: String?,
      status: String,
      priority: String?,
      effort: Long?,
      due_date: String?,
      estimated_minutes: Long?,
      real_minutes: Long?,
      recurrence: String?,
      pomodoro_pool_date: String?,
      order_index: Long,
      completed_at: Long?,
      kind: String?,
      deliverable: String?,
      acceptance: String?,
      created_at: Long,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectByParentQuery(parent_kind, parent_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectByParent(parent_kind: String, parent_id: String?): Query<Task> =
      selectByParent(parent_kind, parent_id) { id, parent_kind_, parent_id_, status_id, title,
      description, status, priority, effort, due_date, estimated_minutes, real_minutes, recurrence,
      pomodoro_pool_date, order_index, completed_at, kind, deliverable, acceptance, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id,
      parent_kind_,
      parent_id_,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByMilestone(parent_id: String?, mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByMilestoneQuery(parent_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectByMilestone(parent_id: String?): Query<Task> = selectByMilestone(parent_id) { id,
      parent_kind, parent_id_, status_id, title, description, status, priority, effort, due_date,
      estimated_minutes, real_minutes, recurrence, pomodoro_pool_date, order_index, completed_at,
      kind, deliverable, acceptance, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id,
      parent_kind,
      parent_id_,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByProject(parent_id: String?, mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByProjectQuery(parent_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectByProject(parent_id: String?): Query<Task> = selectByProject(parent_id) { id,
      parent_kind, parent_id_, status_id, title, description, status, priority, effort, due_date,
      estimated_minutes, real_minutes, recurrence, pomodoro_pool_date, order_index, completed_at,
      kind, deliverable, acceptance, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id,
      parent_kind,
      parent_id_,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByProjectStatus(status_id: String?, mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByProjectStatusQuery(status_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectByProjectStatus(status_id: String?): Query<Task> =
      selectByProjectStatus(status_id) { id, parent_kind, parent_id, status_id_, title, description,
      status, priority, effort, due_date, estimated_minutes, real_minutes, recurrence,
      pomodoro_pool_date, order_index, completed_at, kind, deliverable, acceptance, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id,
      parent_kind,
      parent_id,
      status_id_,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectStandalone(mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(825_127_616, arrayOf("task"), driver, "Task.sq", "selectStandalone", """
  |SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task
  |WHERE parent_kind = 'standalone' AND is_deleted = 0
  |ORDER BY due_date IS NULL, due_date, order_index
  """.trimMargin()) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectStandalone(): Query<Task> = selectStandalone { id, parent_kind, parent_id,
      status_id, title, description, status, priority, effort, due_date, estimated_minutes,
      real_minutes, recurrence, pomodoro_pool_date, order_index, completed_at, kind, deliverable,
      acceptance, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id,
      parent_kind,
      parent_id,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDueBetween(
    due_date: String?,
    due_date_: String?,
    mapper: (
      id: String,
      parent_kind: String,
      parent_id: String?,
      status_id: String?,
      title: String,
      description: String?,
      status: String,
      priority: String?,
      effort: Long?,
      due_date: String?,
      estimated_minutes: Long?,
      real_minutes: Long?,
      recurrence: String?,
      pomodoro_pool_date: String?,
      order_index: Long,
      completed_at: Long?,
      kind: String?,
      deliverable: String?,
      acceptance: String?,
      created_at: Long,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectDueBetweenQuery(due_date, due_date_) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectDueBetween(due_date: String?, due_date_: String?): Query<Task> =
      selectDueBetween(due_date, due_date_) { id, parent_kind, parent_id, status_id, title,
      description, status, priority, effort, due_date__, estimated_minutes, real_minutes,
      recurrence, pomodoro_pool_date, order_index, completed_at, kind, deliverable, acceptance,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id,
      parent_kind,
      parent_id,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date__,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectPending(mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-974_749_444, arrayOf("task"), driver, "Task.sq", "selectPending",
      "SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task WHERE status != 'done' AND is_deleted = 0 ORDER BY due_date IS NULL, due_date") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectPending(): Query<Task> = selectPending { id, parent_kind, parent_id, status_id,
      title, description, status, priority, effort, due_date, estimated_minutes, real_minutes,
      recurrence, pomodoro_pool_date, order_index, completed_at, kind, deliverable, acceptance,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id,
      parent_kind,
      parent_id,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> countByParent(
    parent_kind: String,
    parent_id: String?,
    mapper: (total: Long, done: Long?) -> T,
  ): Query<T> = CountByParentQuery(parent_kind, parent_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)
    )
  }

  public fun countByParent(parent_kind: String, parent_id: String?): Query<CountByParent> =
      countByParent(parent_kind, parent_id) { total, done ->
    CountByParent(
      total,
      done
    )
  }

  public fun <T : Any> selectPomodoroPool(pomodoro_pool_date: String?, mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectPomodoroPoolQuery(pomodoro_pool_date) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectPomodoroPool(pomodoro_pool_date: String?): Query<Task> =
      selectPomodoroPool(pomodoro_pool_date) { id, parent_kind, parent_id, status_id, title,
      description, status, priority, effort, due_date, estimated_minutes, real_minutes, recurrence,
      pomodoro_pool_date_, order_index, completed_at, kind, deliverable, acceptance, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id,
      parent_kind,
      parent_id,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date_,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_538_863_223, arrayOf("task"), driver, "Task.sq", "selectDirty",
      "SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectDirty(): Query<Task> = selectDirty { id, parent_kind, parent_id, status_id,
      title, description, status, priority, effort, due_date, estimated_minutes, real_minutes,
      recurrence, pomodoro_pool_date, order_index, completed_at, kind, deliverable, acceptance,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id,
      parent_kind,
      parent_id,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getString(9),
      cursor.getLong(10),
      cursor.getLong(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getLong(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22),
      cursor.getLong(23)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Task> = selectByIdAnyState(id) { id_,
      parent_kind, parent_id, status_id, title, description, status, priority, effort, due_date,
      estimated_minutes, real_minutes, recurrence, pomodoro_pool_date, order_index, completed_at,
      kind, deliverable, acceptance, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Task(
      id_,
      parent_kind,
      parent_id,
      status_id,
      title,
      description,
      status,
      priority,
      effort,
      due_date,
      estimated_minutes,
      real_minutes,
      recurrence,
      pomodoro_pool_date,
      order_index,
      completed_at,
      kind,
      deliverable,
      acceptance,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(790_915_544, """
        |INSERT INTO task(
        |    id, parent_kind, parent_id, status_id, title, description,
        |    status, priority, effort, due_date, estimated_minutes, real_minutes, recurrence,
        |    pomodoro_pool_date, order_index, completed_at, created_at, updated_at
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 18) {
          bindString(0, id)
          bindString(1, parent_kind)
          bindString(2, parent_id)
          bindString(3, status_id)
          bindString(4, title)
          bindString(5, description)
          bindString(6, status)
          bindString(7, priority)
          bindLong(8, effort)
          bindString(9, due_date)
          bindLong(10, estimated_minutes)
          bindLong(11, real_minutes)
          bindString(12, recurrence)
          bindString(13, pomodoro_pool_date)
          bindLong(14, order_index)
          bindLong(15, completed_at)
          bindLong(16, created_at)
          bindLong(17, updated_at)
        }
    notifyQueries(790_915_544) { emit ->
      emit("task")
    }
  }

  public fun update(
    parent_kind: String,
    parent_id: String?,
    status_id: String?,
    title: String,
    description: String?,
    status: String,
    priority: String?,
    effort: Long?,
    due_date: String?,
    estimated_minutes: Long?,
    real_minutes: Long?,
    recurrence: String?,
    pomodoro_pool_date: String?,
    order_index: Long,
    completed_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_135_861_736, """
        |UPDATE task
        |SET parent_kind = ?, parent_id = ?, status_id = ?, title = ?, description = ?,
        |    status = ?, priority = ?, effort = ?, due_date = ?, estimated_minutes = ?,
        |    real_minutes = ?, recurrence = ?, pomodoro_pool_date = ?, order_index = ?, completed_at = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 17) {
          bindString(0, parent_kind)
          bindString(1, parent_id)
          bindString(2, status_id)
          bindString(3, title)
          bindString(4, description)
          bindString(5, status)
          bindString(6, priority)
          bindLong(7, effort)
          bindString(8, due_date)
          bindLong(9, estimated_minutes)
          bindLong(10, real_minutes)
          bindString(11, recurrence)
          bindString(12, pomodoro_pool_date)
          bindLong(13, order_index)
          bindLong(14, completed_at)
          bindLong(15, updated_at)
          bindString(16, id)
        }
    notifyQueries(1_135_861_736) { emit ->
      emit("task")
    }
  }

  public fun setPomodoroPool(
    pomodoro_pool_date: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-553_677_720,
        """UPDATE task SET pomodoro_pool_date = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, pomodoro_pool_date)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-553_677_720) { emit ->
      emit("task")
    }
  }

  public fun addRealMinutes(
    real_minutes: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(584_857_119,
        """UPDATE task SET real_minutes = COALESCE(real_minutes, 0) + ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, real_minutes)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(584_857_119) { emit ->
      emit("task")
    }
  }

  public fun updateOrder(
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(760_375_366, """UPDATE task SET order_index = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, order_index)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(760_375_366) { emit ->
      emit("task")
    }
  }

  public fun updateStatus(
    status: String,
    completed_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-2_081_878_534,
        """UPDATE task SET status = ?, completed_at = ?, updated_at = ? WHERE id = ?""", 4) {
          bindString(0, status)
          bindLong(1, completed_at)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(-2_081_878_534) { emit ->
      emit("task")
    }
  }

  public fun updateProjectStatus(
    status_id: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_577_515_363,
        """UPDATE task SET status_id = ?, order_index = ?, updated_at = ? WHERE id = ?""", 4) {
          bindString(0, status_id)
          bindLong(1, order_index)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(1_577_515_363) { emit ->
      emit("task")
    }
  }

  public fun markDone(
    completed_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-435_172_530,
        """UPDATE task SET status = 'done', completed_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, completed_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-435_172_530) { emit ->
      emit("task")
    }
  }

  public fun markPending(updated_at: Long, id: String) {
    driver.execute(-239_649_205,
        """UPDATE task SET status = 'pending', completed_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-239_649_205) { emit ->
      emit("task")
    }
  }

  public fun markSkipped(updated_at: Long, id: String) {
    driver.execute(-1_704_584_220,
        """UPDATE task SET status = 'skipped', completed_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-1_704_584_220) { emit ->
      emit("task")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_941_773_844,
        """UPDATE task SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_941_773_844) { emit ->
      emit("task")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-2_111_041_713,
        """UPDATE task SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""", 2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-2_111_041_713) { emit ->
      emit("task")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(1_761_711_637, """DELETE FROM task WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(1_761_711_637) { emit ->
      emit("task")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_150_299_834,
        """UPDATE task SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_150_299_834) { emit ->
      emit("task")
    }
  }

  public fun updateDue(
    due_date: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_590_278_932, """UPDATE task SET due_date = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindString(0, due_date)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_590_278_932) { emit ->
      emit("task")
    }
  }

  public fun updateRecurrence(
    recurrence: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-2_017_651_400,
        """UPDATE task SET recurrence = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, recurrence)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-2_017_651_400) { emit ->
      emit("task")
    }
  }

  public fun setParcoursFields(
    kind: String?,
    deliverable: String?,
    acceptance: String?,
    id: String,
  ) {
    driver.execute(-120_229_339,
        """UPDATE task SET kind = ?, deliverable = ?, acceptance = ? WHERE id = ?""", 4) {
          bindString(0, kind)
          bindString(1, deliverable)
          bindString(2, acceptance)
          bindString(3, id)
        }
    notifyQueries(-120_229_339) { emit ->
      emit("task")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("task", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("task", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(880_879_245,
        """SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Task.sq:selectById"
  }

  private inner class SelectByParentQuery<out T : Any>(
    public val parent_kind: String,
    public val parent_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("task", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("task", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task
    |WHERE parent_kind = ? AND parent_id ${ if (parent_id == null) "IS" else "=" } ? AND is_deleted = 0
    |ORDER BY order_index, due_date IS NULL, due_date
    """.trimMargin(), mapper, 2) {
      bindString(0, parent_kind)
      bindString(1, parent_id)
    }

    override fun toString(): String = "Task.sq:selectByParent"
  }

  private inner class SelectByMilestoneQuery<out T : Any>(
    public val parent_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("task", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("task", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task
    |WHERE parent_kind = 'milestone' AND parent_id ${ if (parent_id == null) "IS" else "=" } ? AND is_deleted = 0
    |ORDER BY order_index, due_date IS NULL, due_date
    """.trimMargin(), mapper, 1) {
      bindString(0, parent_id)
    }

    override fun toString(): String = "Task.sq:selectByMilestone"
  }

  private inner class SelectByProjectQuery<out T : Any>(
    public val parent_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("task", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("task", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task
    |WHERE parent_kind = 'project' AND parent_id ${ if (parent_id == null) "IS" else "=" } ? AND is_deleted = 0
    |ORDER BY order_index, due_date IS NULL, due_date
    """.trimMargin(), mapper, 1) {
      bindString(0, parent_id)
    }

    override fun toString(): String = "Task.sq:selectByProject"
  }

  private inner class SelectByProjectStatusQuery<out T : Any>(
    public val status_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("task", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("task", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task
    |WHERE status_id ${ if (status_id == null) "IS" else "=" } ? AND is_deleted = 0
    |ORDER BY order_index
    """.trimMargin(), mapper, 1) {
      bindString(0, status_id)
    }

    override fun toString(): String = "Task.sq:selectByProjectStatus"
  }

  private inner class SelectDueBetweenQuery<out T : Any>(
    public val due_date: String?,
    public val due_date_: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("task", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("task", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-2_279_953, """
    |SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task
    |WHERE due_date BETWEEN ? AND ? AND is_deleted = 0
    |ORDER BY due_date, order_index
    """.trimMargin(), mapper, 2) {
      bindString(0, due_date)
      bindString(1, due_date_)
    }

    override fun toString(): String = "Task.sq:selectDueBetween"
  }

  private inner class CountByParentQuery<out T : Any>(
    public val parent_kind: String,
    public val parent_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("task", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("task", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT COUNT(*) AS total,
    |       SUM(CASE WHEN status = 'done' THEN 1 ELSE 0 END) AS done
    |FROM task
    |WHERE parent_kind = ? AND parent_id ${ if (parent_id == null) "IS" else "=" } ? AND is_deleted = 0
    """.trimMargin(), mapper, 2) {
      bindString(0, parent_kind)
      bindString(1, parent_id)
    }

    override fun toString(): String = "Task.sq:countByParent"
  }

  private inner class SelectPomodoroPoolQuery<out T : Any>(
    public val pomodoro_pool_date: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("task", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("task", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task
    |WHERE pomodoro_pool_date ${ if (pomodoro_pool_date == null) "IS" else "=" } ? AND is_deleted = 0
    |ORDER BY status != 'done', order_index
    """.trimMargin(), mapper, 1) {
      bindString(0, pomodoro_pool_date)
    }

    override fun toString(): String = "Task.sq:selectPomodoroPool"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("task", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("task", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-469_214_286,
        """SELECT task.id, task.parent_kind, task.parent_id, task.status_id, task.title, task.description, task.status, task.priority, task.effort, task.due_date, task.estimated_minutes, task.real_minutes, task.recurrence, task.pomodoro_pool_date, task.order_index, task.completed_at, task.kind, task.deliverable, task.acceptance, task.created_at, task.updated_at, task.is_deleted, task.deleted_at, task.synced_at FROM task WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Task.sq:selectByIdAnyState"
  }
}
